import { useEffect, useState } from "react";
import Header from "../components/common/header";
import Footer from "../components/common/footer";

export default function BehaviorPage() {
  const [wallets, setWallets] = useState({});

  useEffect(() => {
    const ws = new WebSocket("wss://cryptospace.network/wallet-feed");

    ws.onmessage = (e) => {
      try {
        const msg = JSON.parse(e.data);
        const p = msg.payload || {};

        const wallet = p.from || p.to;
        if (!wallet) return;

        setWallets((prev) => {
          const old = prev[wallet] || {
            count: 0,
            swaps: 0,
            contractCalls: 0,
            bot: 0,
            gas: 0,
            lastSeen: 0,
          };

          const updated = {
            ...old,
            count: old.count + 1,
            swaps:
              old.swaps +
              (msg.event === "REAL_SWAP" || msg.event === "SWAP_TOKENS" ? 1 : 0),
            contractCalls:
              old.contractCalls +
              (msg.event === "CONTRACT_CALL" ? 1 : 0),
            bot: old.bot + (msg.event === "BOT_LIKE_TX" ? 1 : 0),
            gas: old.gas + (msg.event === "GAS_SPIKE" ? 1 : 0),
            lastSeen: Date.now(),
          };

          return {
            ...prev,
            [wallet]: updated,
          };
        });
      } catch (err) {
        // игнор битых сообщений
      }
    };

    return () => ws.close();
  }, []);

  // 🔥 считаем рейтинг
  const ranked = Object.entries(wallets)
    .map(([addr, w]) => {
      const score =
        w.swaps * 50 +
        w.contractCalls * 20 +
        w.bot * 40 +
        w.gas * 10 +
        w.count * 5;

      return { addr, ...w, score };
    })
    .sort((a, b) => b.score - a.score)
    .slice(0, 30);

  const getLabel = (w) => {
    if (w.bot > 5) return "🤖 Bot";
    if (w.swaps > 5) return "💰 Trader";
    if (w.contractCalls > 5) return "🧠 Contract User";
    if (w.gas > 3) return "⚠️ Risky";
    return "👤 Normal";
  };

  return (
    <div style={{ minHeight: "100vh", background: "#000", color: "#fff" }}>
      <Header />

      <div style={{ padding: 24, maxWidth: 1100, margin: "0 auto" }}>
        <h1 style={{ fontSize: 32, marginBottom: 10 }}>
          🧠 Behavior Intelligence
        </h1>

        <p style={{ color: "#aaa", marginBottom: 20 }}>
          Real-time classification of wallet behavior
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          {ranked.map((w, i) => (
            <div
              key={w.addr}
              style={{
                padding: 16,
                border: "1px solid #222",
                borderRadius: 10,
                background: "#0a0a0a",
              }}
            >
              <div style={{ fontSize: 12, color: "#777" }}>
                {w.addr}
              </div>

              <div style={{ fontSize: 20, margin: "6px 0" }}>
                #{i + 1} {getLabel(w)}
              </div>

              <div style={{ color: "#6ab7ff" }}>
                Score: {w.score}
              </div>

              <div style={{ fontSize: 13, marginTop: 6 }}>
                Trades: {w.count}
              </div>

              <div style={{ fontSize: 13, color: "#aaa" }}>
                Swaps: {w.swaps} | Contracts: {w.contractCalls}
              </div>

              <div style={{ fontSize: 13, color: "#aaa" }}>
                Bot: {w.bot} | Gas: {w.gas}
              </div>

              <div style={{ fontSize: 12, color: "#555", marginTop: 6 }}>
                last seen: {Math.floor((Date.now() - w.lastSeen) / 1000)}s ago
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
}